export default __webpack_public_path__ + "static/media/show-lamp-1.be654d25.webp";